module.exports = __webpack_public_path__ + "img/icon-google.11755d86.svg";